<script setup lang="ts"></script>

<template>
  <div class="flex flex-col text-purple-gray text-base md:text-[20px] leading-6 tracking-[-0.6px] gap-6">
    <span>Unlock Element 6 & enter the exclusive club!</span>

    <div class="flex flex-col gap-0">
      <span>💰 <span class="text-lavender">Supercharged Staking</span> – Get up to 30% APY on your stake.</span>
      <span>🎁 <span class="text-lavender">Airdrop King Status</span> – Claim a share of 30% in 3 airdrops of your choice!</span>
      <span>🚗 <span class="text-lavender">Year-End Jackpot</span> – Secure an exclusive ticket for a luxury car giveaway!</span>
    </div>
  </div>
</template>

<style scoped></style>
